import { useTranslation } from 'react-i18next';

import { StaticPageLayout } from '../components/layout/StaticPageLayout';

function Section({
  titleKey,
  children,
}: {
  titleKey: string;
  children: React.ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <section>
      <h2 className="text-xl font-heading font-semibold text-brand-accent mb-3">
        {t(titleKey)}
      </h2>
      <p className="text-neutral-medium font-body leading-relaxed">{children}</p>
    </section>
  );
}

export function AboutPage() {
  const { t } = useTranslation();

  return (
    <StaticPageLayout
      titleKey="staticPages.about.title"
      subtitleKey="staticPages.about.subtitle"
    >
      <p className="text-neutral-medium font-body leading-relaxed">
        {t('staticPages.about.intro')}
      </p>
      <Section titleKey="staticPages.about.mission">
        {t('staticPages.about.missionText')}
      </Section>
      <Section titleKey="staticPages.about.values">
        {t('staticPages.about.valuesText')}
      </Section>
      <p className="text-neutral-medium font-body leading-relaxed pt-2">
        {t('staticPages.about.contact')}
      </p>
    </StaticPageLayout>
  );
}
